/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const PredictionDeactivatedRoundedIcon: FC<AllieIconProps> = () => (
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.416992 16C0.416992 7.16344 7.58044 0 16.417 0C25.2535 0 32.417 7.16344 32.417 16C32.417 24.8366 25.2535 32 16.417 32C7.58044 32 0.416992 24.8366 0.416992 16Z"
      fill="#98A2B3"
    />
    <path
      d="M14.4172 10.6667V9.33333M18.4172 21.3333V22.6667M11.0838 14H9.75049M21.7505 18H23.0838M11.6933 11.2761L10.7505 10.3333M21.141 20.7239L22.0838 21.6667M16.4172 19.7712L15.0029 21.1854C13.9615 22.2268 12.2731 22.2268 11.2317 21.1854C10.1903 20.144 10.1903 18.4556 11.2317 17.4142L12.6459 16M20.1884 16L21.6026 14.5858C22.644 13.5444 22.644 11.8559 21.6026 10.8145C20.5612 9.77315 18.8728 9.77315 17.8314 10.8145L16.4172 12.2288"
      stroke="#D0D5DD"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
